import React from 'react'
import AdsTable from '../../modules/Ad/components/AdsTable'

export default function AdPage() {
  return <AdsTable />
}